import { fromJS} from 'immutable'
import actionTypes from '../actionTypes'

const defaultStatus = fromJS ({
  sensingDisplay: {},
  sensingDownload:{}
})

export default (state = defaultStatus, action) => {
  switch (action.type) {
    case actionTypes.SensingDisplay:
      return state.merge({
        sensingDisplay: (action.data),
      });
      case actionTypes.SensingDownload:
        return state.merge({
          sensingDownload: (action.data),
        });
    default:
      break;
  }

  return state
}